var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import { api } from '../../helpers/Api';
import DiscountCode from '../DiscountCodes/DiscountCode';
var DiscountCodesStore = /** @class */ (function () {
    function DiscountCodesStore() {
        var _this = this;
        this.data = [];
        this.loaded = false;
        this.read = function (id) {
            if (id)
                return api.get('discountcodes/' + id).then(function (value) {
                    _this.loaded = true;
                    return value;
                });
            return api.get('discountcodes').then(function (value) {
                return _this.set(value);
            });
        };
        this.set = function (values) {
            _this.data = values.map(function (item) { return new DiscountCode(item); });
            _this.loaded = true;
            return _this.data;
        };
        this.push = function (value) {
            _this.data.push(new DiscountCode(value));
            return _this.data;
        };
        this.replace = function (value) {
            _this.data.splice(_this.data.findIndex(function (f) { return f.id === value.id; }), 1, value);
            return _this.data;
        };
        this.pull = function (value) {
            _this.data.splice(_this.data.findIndex(function (a) { return a.id === value.id; }), 1);
        };
    }
    DiscountCodesStore.prototype.create = function (value) {
        return api.post('discountcodes', value).then(this.push);
    };
    DiscountCodesStore.prototype.update = function (id, data) {
        return api.put('discountcodes/' + id, data).then(this.replace);
    };
    DiscountCodesStore.prototype.disable = function (id, disabled) {
        return api.patch('discountcodes/' + id, { disabled: disabled }).then(this.pull);
    };
    __decorate([
        observable
    ], DiscountCodesStore.prototype, "data", void 0);
    __decorate([
        observable
    ], DiscountCodesStore.prototype, "loaded", void 0);
    __decorate([
        action
    ], DiscountCodesStore.prototype, "read", void 0);
    __decorate([
        action
    ], DiscountCodesStore.prototype, "set", void 0);
    __decorate([
        action
    ], DiscountCodesStore.prototype, "push", void 0);
    __decorate([
        action
    ], DiscountCodesStore.prototype, "replace", void 0);
    __decorate([
        action
    ], DiscountCodesStore.prototype, "pull", void 0);
    return DiscountCodesStore;
}());
export default DiscountCodesStore;



//////////////////
// WEBPACK FOOTER
// ./src/modules/DiscountCodes/DiscountCodesStore.ts
// module id = 747
// module chunks = 0